import React, { useEffect, useMemo } from 'react';
import { translate } from 'components/Translation';
// import ActivateCpnDialog from './subcomponents/ActivateCpnDialog';
// import DeactivateCpnDialog from './subcomponents/DeactivateCpnDialog';
import AccordionContent from '../../../common/AccordionContent';
// import ActivateShortcodeDialog from './subcomponents/ActivateShortcodeDialog';
// import DeactivateShortcodeDialog from './subcomponents/DeactivateShortcodeDialog';
// import { NumbersService } from 'services/numbers/numbers';
// import { finalize } from 'rxjs/operators';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
// import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';

interface ICpnAccordionContentProps {
	showOnlyActive: boolean;
	termsAndConditions: types.services.termsAndConditions;
	phoneNumber: string;
	accountDetails: string;
	accountNumber: string;
	setIsCpnActive: React.Dispatch<React.SetStateAction<boolean>>;
}

// type dialog =
// 	| 'cpnActivationDialog'
// 	| 'cpnDeactivationDialog'
// 	| 'shortcodeActivationDialog'
// 	| 'shortcodeEditDialog'
// 	| 'shortcodeDeactivationDialog';

const CpnAccordionContentWrapper = ({
	showOnlyActive,
	termsAndConditions,
	setIsCpnActive,
}: // phoneNumber,
// accountDetails,
// accountNumber,
ICpnAccordionContentProps) => {
	// const [cpnActive, setCpnActive] = useState<boolean>(false);
	// const [shortCode, setShortcode] = useState<string>('');
	// const [showDialog, setShowDialog] = useState<dialog | null>(null);
	// const [productId, setProductId] = useState<string>('5544');
	// const [loading, setLoading] = useState<boolean>(false);

	// const getCpnAccount = useCallback(() => {
	// setLoading(true);
	// NumbersService.getCpnAccount(accountNumber, phoneNumber)
	// 	.pipe(finalize(() => setLoading(false)))
	// 	.subscribe(({ subscriberCode, cpnAccountNo, shortCode }) => {
	// 		setCpnActive(!!subscriberCode && !!cpnAccountNo);
	// 		if (shortCode) {
	// 			setShortcode(shortCode);
	// 		}
	// 	});
	// }, [phoneNumber, accountNumber]);

	// const updateCpn = (singlePackage: types.services.IPackage) => {
	// 	if (singlePackage.id === 'NAMA_CPN') {
	// 		if (!cpnActive) {
	// 			showCpnActivationDialog();
	// 		} else {
	// 			showCpnDeactivationDialog();
	// 		}
	// 	} else if (singlePackage.id === 'NAMA_CPN_SHORTCODE') {
	// 		if (shortCode) {
	// 			showShortcodeDeactivationDialog();
	// 		} else {
	// 			showShortcodeActivationDialog();
	// 		}
	// 	}
	// };

	// const hideDialog = () => {
	// 	setShowDialog(null);
	// };
	//
	// const showCpnDeactivationDialog = () => {
	// 	setShowDialog('cpnDeactivationDialog');
	// };
	//
	// const showCpnActivationDialog = () => {
	// 	setShowDialog('cpnActivationDialog');
	// };
	//
	// const showShortcodeActivationDialog = () => {
	// 	setShowDialog('shortcodeActivationDialog');
	// };

	// const showShortcodeEditDialog = () => {
	// 	setShowDialog('shortcodeEditDialog');
	// };

	// const showShortcodeDeactivationDialog = () => {
	// 	setShowDialog('shortcodeDeactivationDialog');
	// };
	//
	// const update = () => {
	// 	getCpnAccount();
	// };

	const CPNPackages: types.services.IPackage[] = useMemo(() => {
		// const cpnShortcodeName = shortCode
		// 	? translate('number.services.shortcode.selected', shortCode)
		// 	: translate('number.services.shortcode');
		//
		// // TODO add description when plans will be available
		// const cpnDescription = cpnActive
		// 	? // ? translate(`number.services.CPN.description.${cpnActive}`)
		// 	  undefined
		// 	: translate('number.services.CPN.description');

		return [
			{
				name: translate('number.services.nama.CPN'),
				id: 'NAMA_CPN',
				status: {
					type: 'INACTIVE',
				},
				legacyProductId: '',
				place: '',
				tooltip: {
					content: translate('number.services.cpn.tooltip'),
				},
				description: translate('services.coming.soon'),
				buttons: [],
			},
			// cpnActive && {
			// 	name: cpnShortcodeName,
			// 	id: 'NAMA_CPN_SHORTCODE',
			// 	status: {
			// 		active: !!shortCode,
			// 	},
			// 	legacyProductId: '',
			// 	place: '',
			// 	description: translate('number.services.CPN.shortcode.description'),
			// 	edit: !!shortCode && showShortcodeEditDialog,
			// },
		];
		// }, [cpnActive, shortCode]);
	}, []);

	const filteredCPNPackages = useMemo(() => {
		return CPNPackages.filter(
			(singlePackage) =>
				!showOnlyActive || singlePackage.status?.type !== 'ACTIVE' || singlePackage.id === 'NAMA_CPN'
		);
	}, [CPNPackages, showOnlyActive]);

	// useEffect(() => {
	// 	getCpnAccount();
	// }, [getCpnAccount]);

	useEffect(() => {
		setIsCpnActive(filteredCPNPackages.some((pckg) => pckg.status?.type === 'ACTIVE'));
	}, [filteredCPNPackages]);

	return (
		<>
			<ConditionalRender
				// show={loading}
				show={false}
				// onTrue={() => <CustomCircularProgress text={translate('number.loading.packages')} loading={loading} />}
				onFalse={() => (
					<AccordionContent
						elements={filteredCPNPackages}
						termsAndConditions={termsAndConditions}
						// updateService={updateCpn}
						updateService={() => {}}
						// disabled={true}
					/>
				)}
			/>
			{/*<ActivateCpnDialog*/}
			{/*	isOpen={showDialog === 'cpnActivationDialog'}*/}
			{/*	hideDialog={hideDialog}*/}
			{/*	update={update}*/}
			{/*	currentProductId={productId}*/}
			{/*	phoneNumber={phoneNumber}*/}
			{/*	billingId={accountNumber}*/}
			{/*	termsAndConditions={{*/}
			{/*		...termsAndConditions,*/}
			{/*		text: translate('number.services.mobile.nama.cpn.terms'),*/}
			{/*	}}*/}
			{/*/>*/}
			{/*<DeactivateCpnDialog*/}
			{/*	isOpen={showDialog === 'cpnDeactivationDialog'}*/}
			{/*	hideDialog={hideDialog}*/}
			{/*	update={update}*/}
			{/*	phoneNumber={phoneNumber}*/}
			{/*	billingId={accountNumber}*/}
			{/*	shortCode={shortCode}*/}
			{/*	productId={productId}*/}
			{/*/>*/}
			{/*<ActivateShortcodeDialog*/}
			{/*	isOpen={showDialog === 'shortcodeActivationDialog' || showDialog === 'shortcodeEditDialog'}*/}
			{/*	hideDialog={hideDialog}*/}
			{/*	phoneNumber={phoneNumber}*/}
			{/*	accountDetails={accountDetails}*/}
			{/*	update={update}*/}
			{/*	edit={showDialog === 'shortcodeEditDialog'}*/}
			{/*	currentShortCode={shortCode}*/}
			{/*/>*/}
			{/*<DeactivateShortcodeDialog*/}
			{/*	isOpen={showDialog === 'shortcodeDeactivationDialog'}*/}
			{/*	hideDialog={hideDialog}*/}
			{/*	update={update}*/}
			{/*	currentShortCode={shortCode}*/}
			{/*	phoneNumber={phoneNumber}*/}
			{/*/>*/}
		</>
	);
};

export default CpnAccordionContentWrapper;
